<!-- ============================================================== -->
<!-- toggle and nav items -->
<!-- ============================================================== -->
<ul class="navbar-nav">
    <li class="nav-item d-none d-md-block">
        <a (click)="toggleSidebar.emit()" class="nav-link sidebartoggler waves-effect waves-light"
            href="javascript:void(0)">
            <i class="mdi mdi-menu font-24"></i>
        </a>
    </li>
</ul>

<ul class="navbar-nav flex-grow-1">
    <li class="nav-item flex-fill" *ngFor="let item of listMenuItems;"
        [class.d-none]="item.limitEnv.includes(envName) === false">
        <button type="button" class="btn nav-link"
            [attr.id]="item.id"
            [routerLink]="[item.path]">
            <div class="d-flex">
                <i [ngClass]="item.icon"></i>
                <span class="d-none d-md-block ml-1">
                    {{item.title}}
                </span>
            </div>
        </button>
    </li>
    <!-- <li class="nav-item flex-fill">
        <button type="button" class="btn nav-link"
            id="menu-01"
            [routerLink]="['/dtg/car/current/list']">
            <div class="d-flex">
                <i class="mdi mdi-google-maps font-24"></i>
                <span class="d-none d-md-block ml-1">
                    메인
                </span>
            </div>
        </button>
    </li>
    <li class="nav-item flex-fill">
        <button type="button" class="btn nav-link"
            id="menu-02"
            [routerLink]="['/dtg/analytics/dashboard']">
            <div class="d-flex">
                <i class="mdi mdi-clipboard-check font-24"></i>
                <span class="d-none d-md-block ml-1">
                    운행일지
                </span>
            </div>
        </button>
    </li>
    <li class="nav-item flex-fill">
        <button type="button" class="btn nav-link"
            id="menu-03"
            [routerLink]="['/dtg/analytics/drive/safe/summary']">
            <div class="d-flex">
                <i class="mdi mdi-chart-bar font-24"></i>
                <span class="d-none d-md-block ml-1">
                    리포트
                </span>
            </div>
        </button>
    </li>
    <li class="nav-item flex-fill">
        <button type="button" class="btn nav-link"
            id="menu-04"
            [routerLink]="['/dtg/manage/driver/main']">
            <div class="d-flex">
                <i class="mdi mdi-checkbox-marked-outline font-24"></i>
                <span class="d-none d-md-block ml-1">
                    환경설정
                </span>
            </div>
        </button>
    </li>
    <li class="nav-item flex-fill"
        [hidden]="userGroupId > 1">
        <button type="button" class="btn nav-link"
            id="menu-05"
            [routerLink]="['/dtg/danger/drive/config']">
            <div class="d-flex">
                <i class="mdi mdi-flask-outline font-24"></i>
                <span class="d-none d-md-block ml-1">
                    테스트
                </span>
            </div>
        </button>
    </li> -->
</ul>
<!-- ============================================================== -->
<!-- Right side toggle and nav items -->
<!-- ============================================================== -->
<ul class="navbar-nav">
    <li class="nav-item d-flex align-items-center">
        <company-selector></company-selector>
    </li>
    <li class="nav-item d-flex align-items-center"
        *ngIf="isShowDateSelector">
        <date-selector></date-selector>
    </li>
    <li class="nav-item d-flex align-items-center">
        <user-info></user-info>
    </li>
    <li class="nav-item" ngbDropdown placement="bottom-right" #ddNotice="ngbDropdown">
        <button type="button" class="btn nav-link waves-effect waves-dark" ngbDropdownToggle>
            <i class="mdi mdi-bullhorn font-24"></i>
            <small>
                <span class="badge badge-pill badge-warning"
                    style="position: absolute;top: 10px;right: 0px;"
                    *ngIf="newNoticeCnt > 0">
                    {{newNoticeCnt}}
                </span>
            </small>
        </button>
        <div class="dropdown-menu dropdown-menu-right mailbox" ngbDropdownMenu>
            <span class="with-arrow">
                <span class="bg-danger"></span>
            </span>
            <ul class="list-style-none">
                <li>
                    <div class="drop-title bg-danger text-white">
                        <h4 class="m-b-0 m-t-5">{{newNoticeCnt}} New</h4>
                        <span class="font-light">공지사항</span>
                    </div>
                </li>
                <li>
                    <div class="message-center notifications" [perfectScrollbar]="config">
                        <!-- Message -->
                        <ng-container *ngFor="let notification of noticeList; let i=index;"> 
                            <a *ngIf="i<4" href="javascript:void(0)" class="message-item" (click)="clickNoticeDetailModal(notification)">
                                <span class="btn btn-circle {{notification.btn}}">
                                    <i class="{{notification.icon}}"></i>
                                </span>
                                <span class="mail-contnet">
                                    <h5 class="message-title">{{notification.title}}</h5>
                                    <span class="mail-desc" style="max-width: 300px;" [innerHtml]="parseContent(notification.content)"></span>
                                    <span class="time">{{notification.createDt}}</span>
                                </span>
                            </a>
                        </ng-container>
                    </div>
                </li>
                <li>
                    <a class="nav-link text-center m-b-5" href="javascript:void(0);"
                        (click)="$event.stopPropagation();ddNotice.close();"
                        [routerLink]="['/dtg/notice/main']">
                        <strong>View All</strong>
                    </a>
                </li>
            </ul>
        </div>
    </li>
    <!-- ============================================================== -->
    <!-- Comment -->
    <!-- ============================================================== -->
    <li class="nav-item" ngbDropdown placement="bottom-right">
        <button type="button" class="btn nav-link waves-effect waves-dark" ngbDropdownToggle>
            <i class="mdi mdi-bell font-24"></i>
            <small>
                <span class="badge badge-pill badge-warning"
                    style="position: absolute;top: 10px;right: 0px;"
                    *ngIf="listItemAlert.length > 0">
                    {{listItemAlert.length}}
                </span>
            </small>
        </button>
        <div class="dropdown-menu dropdown-menu-right mailbox" ngbDropdownMenu>
            <span class="with-arrow">
                <span class="bg-primary"></span>
            </span>
            <ul class="list-style-none">
                <li>
                    <div class="drop-title bg-primary text-white">
                        <h4 class="m-b-0 m-t-5">{{listItemAlert.length}} New</h4>
                        <span class="font-light">알림메세지</span>
                    </div>
                </li>
                <li>
                    <div class="message-center notifications" [perfectScrollbar]="config">
                        <!-- Message -->
                        <div class="d-flex w-100 justify-content-start align-items-center border-bottom px-3 py-2 pointer"
                            *ngFor="let itemAlert of listItemAlert;let idx = index;">
                            <div>
                                <span class="fa-stack">
                                    <i class="fas fa-circle fa-stack-2x" [ngClass]="'text-'+itemAlert.level"></i>
                                    <i class="fas {{itemAlert.icon}} fa-stack-1x fa-inverse"></i>
                                </span>
                            </div>
                            <span class="pl-3">
                                <div class="d-flex justify-content-between align-items-center">
                                    <b>{{itemAlert.title}}</b>
                                    <a href="javascript:void(0)" class="py-0" (click)="clickAlertMessageRemove(itemAlert)">
                                        <i class="far fa-times-circle fa-fw"></i>
                                    </a>
                                </div>
                                <div class="small text-muted mt-1" [innerHTML]="itemAlert.body"></div>
                                <div class="small text-muted mt-1">{{itemAlert.dateUpdate | date:'yyyy-MM-dd HH:mm:ss'}}</div>
                            </span>
                        </div>
                    </div>
                </li>
                <li>
                    <a class="nav-link text-center m-b-5" href="javascript:void(0);">
                        <strong>Check all notifications</strong>
                        <i class="fa fa-angle-right"></i>
                    </a>
                </li>
            </ul>
        </div>
    </li>
    <!-- ============================================================== -->
    <!-- End Comment -->
    <!-- ============================================================== -->
</ul>